// @ts-nocheck
import React from 'react';
import { useHotelAssignedEvents } from './hooks/useHotelAssignedEvents';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { useNavigate } from 'react-router-dom';
import { CalendarDays, MapPin } from 'lucide-react';
import { format, parseISO } from 'date-fns';

const HotelTracker: React.FC = () => {
  const { data: events, isLoading } = useHotelAssignedEvents();
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Team Tracker</h1>

      {isLoading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="h-40 rounded-lg" />
          ))}
        </div>
      ) : !events || events.length === 0 ? (
        <Card>
          <CardContent className="py-12 text-center text-muted-foreground">
            No events assigned yet.
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {events.map((ev) => (
            <Card
              key={ev.event_id}
              className="flex flex-col cursor-pointer hover:shadow-md transition-shadow"
              onClick={() => navigate(`/hotel-portal/events/${ev.event_id}`)}
            >
              <CardContent className="flex flex-col gap-3 p-5 flex-1">
                <h3 className="text-lg font-semibold">{ev.event_name}</h3>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <CalendarDays className="h-4 w-4 shrink-0" />
                  {ev.start_date ? format(parseISO(ev.start_date), 'MMM d, yyyy') : '—'}
                  {ev.end_date && ev.end_date !== ev.start_date
                    ? ` – ${format(parseISO(ev.end_date), 'MMM d, yyyy')}`
                    : ''}
                </div>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <MapPin className="h-4 w-4 shrink-0" />
                  {[ev.venue_city, ev.venue_state].filter(Boolean).join(', ') || 'Location TBD'}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default HotelTracker;
